import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { PageHeader } from 'src/components/common/page-header';
import { Routes } from 'src/components/common/router/constants';
import { useQuery } from '@apollo/client';
import {
  ResourceByIdDocument,
  ResourceByIdQuery,
  ResourcePageType,
} from 'src/graphql/generated/graphql';
import { ResourceForm } from 'src/components/resource/form';

export const ResourceFormPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const goBack = () => navigate(-1);

  const { id } = useParams();

  const { data, loading } = useQuery<ResourceByIdQuery>(ResourceByIdDocument, {
    variables: {
      id,
    },
    skip: !id,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only',
  });

  const type =
    data?.resourceById?.type ||
    (searchParams.get('type') as ResourcePageType) ||
    ResourcePageType.Document;

  const title = !id
    ? t(`resources.form.create-${type.toLowerCase()}`)
    : t(`resources.form.edit-${type.toLowerCase()}`);

  const breadCrumbsProps = {
    items: [
      {
        label: t('resources.breadcrumbs.resources'),
        url: Routes.roles.path,
      },
      {
        label: title,
      },
    ],
  };

  return (
    <>
      <PageHeader title={title} breadcrumbs={breadCrumbsProps} />
      {!loading && (
        <ResourceForm
          type={type}
          resource={data?.resourceById}
          onCancel={goBack}
          onSave={goBack}
        />
      )}
    </>
  );
};

export default ResourceFormPage;
